module.exports = __webpack_public_path__ + "static/6-0d0df02ea0142a02b86f69eb436a8027.jpg";